var exports = {
  "ZK": "ChannelFollowSuccessModal.module__hero___ZG5kOW",
  "Wp": "ChannelFollowSuccessModal.module__patternImage___ZG5kOW",
  "RG": "ChannelFollowSuccessModal.module__composition___ZG5kOW",
  "Dr": "ChannelFollowSuccessModal.module__sourceIconWrap___ZG5kOW",
  "$f": "ChannelFollowSuccessModal.module__guildIcon___ZG5kOW",
  "hI": "ChannelFollowSuccessModal.module__announcementBadge___ZG5kOW",
  "aw": "ChannelFollowSuccessModal.module__announcementBadgeIcon___ZG5kOW",
  "UE": "ChannelFollowSuccessModal.module__arrow___ZG5kOW",
  "rf": "ChannelFollowSuccessModal.module__body___ZG5kOW",
  "DD": "ChannelFollowSuccessModal.module__title___ZG5kOW",
  "h_": "ChannelFollowSuccessModal.module__description___ZG5kOW",
};

module.exports = exports;
